import {adminServerInstance} from "../axios/instances";
import {DELIVERY_EFFICIENCY_MONITOR as type} from "./deliveryEfficiencyMonitorTypes";
import axios from "axios";
import {getUserPreference} from "../utilities/common";

export function handleRowValues(params) {
    return function (dispatch) {
        dispatch({type: type.HANDLE_ROW_VALUES})
        return (
            dispatch({
                type: type.HANDLE_ROW_VALUES,
                payload: params
            })
        )
    }
}

export function getUserTeam(userId, city) {
    return function (dispatch) {
        dispatch({type: type.DRIVER_EFFICIENCY_USER_TEAM_LOAD})
        return adminServerInstance.get(`/driver/queryuserteams?user_id=${userId}&warehouse=${city}`)
            .then(({data}) => {
                dispatch({
                    type: type.DRIVER_EFFICIENCY_USER_TEAM_LOAD_SUCCESS,
                    payload: data.data,
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.DRIVER_EFFICIENCY_USER_TEAM_LOAD_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}
/**
 *
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.sub_references - sub-batch numbers
 * @param {number} params.team_id - team ID
 * @param {number} params.is_express - 0|1
 * @param {string} params.driver_ids- driver ids
 * @param {number} params.partner_id- partner ID
 */
export function getDeliveryReport(params) {
    return function (dispatch) {
        dispatch({type: type.DRIVER_EFFICIENCY_DATA_LOAD})
        return adminServerInstance.get(`/driver/deliveryrealtimestatistic`, {
            params: params
        })
            .then(({data}) => {
                dispatch({
                    type: type.DRIVER_EFFICIENCY_DATA_LOAD_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.DRIVER_EFFICIENCY_DATA_LOAD_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

/**
 *
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.sub_references - sub-batch numbers
 * @param {number} params.team_id - team ID
 * @param {number} params.is_express - 0|1
 * @param {number} params.driver_id- driver ID
 * @param {number} params.state- state code
 * @param {number} params.partner- partner ID
 */
export function getDeliveryRealTimeDetails(params) {
    return function (dispatch) {
        dispatch({type: type.DRIVER_EFFICIENCY_STATUS_DETAIL_LOAD})
        return adminServerInstance.get(`/driver/deliveryrealtimedetails`, {
            params: params
        })
            .then(({data}) => {
                dispatch({
                    type: type.DRIVER_EFFICIENCY_STATUS_DETAIL_LOAD_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.DRIVER_EFFICIENCY_STATUS_DETAIL_LOAD_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function getAlertRule() {
    return function (dispatch) {
        dispatch({type: type.DRIVER_EFFICIENCY_ALERT_RULE_DETAIL_LOAD})
        return adminServerInstance.get(`/driver/queryalertrules`)
            .then(({data}) => {
                dispatch({
                    type: type.DRIVER_EFFICIENCY_ALERT_RULE_DETAIL_LOAD_SUCCESS,
                    payload: data.data,
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.DRIVER_EFFICIENCY_ALERT_RULE_DETAIL_LOAD_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }

}


/**
 *
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.sub_references - sub-batch numbers
 * @param {number} params.team_id - team ID
 * @param {number} params.is_express - 0|1
 * @param {string} params.driver_ids- driver ids
 * @param {number} params.partner_id- partner ID
 */
export function downloadDriverEfficiencyExcelBlob(params) {
    return axios.post(`${process.env.REACT_APP_MAP_SERVER_URL}/driver/dowloaddriverefficiency`, params, {
        responseType: 'blob',
        headers: {
            'Authorization': `Bearer ${getUserPreference().authToken}`
        },
        timeout: 0
    })
        .then((response) => {
            if (response.headers['content-type'] === "application/json") {
                return Promise.reject(response);
            } else {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'driverEfficiency.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        })
        .catch((error) => {
            return Promise.reject(error);
        })
}
